import React from 'react';

import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';

import bannerImage from 'src/assets/home/new-banner-hires.webp';

import { FREE_SUBSCRIPTION_ROUTES, PUBLIC_ROUTES } from 'src/constants/routes';
import { useStyles } from './styles';

export const Banner = () => {
  const classes = useStyles();
  const isLogged = useSelector(state => state.user.isAuthenticated);
  return (
    <Grid container alignItems="center" className={classes.container}>
      <Grid item xs={12} md={4} className={classes.leftColumn}>
        <Typography variant="h1">Get paid on time</Typography>
        <Box mt={2.5} mb={6}>
          <Typography style={{ fontSize: 20 }}>Take control of collections of solve your cash flow problems</Typography>
        </Box>
        <Button
          variant="contained"
          color="primary"
          className={classes.button}
          component={Link}
          to={isLogged ? FREE_SUBSCRIPTION_ROUTES.ACCOUNT_ONBOARDING : PUBLIC_ROUTES.REGISTER}
        >
          Get started
        </Button>
      </Grid>
      <Grid item xs={12} md={8} className={classes.bannerContainer}>
        <img src={bannerImage} alt="banner" className={classes.banner} />
      </Grid>
    </Grid>
  );
};
